/**
 * Helper to validate includes array at runtime
 */
export const VALID_RELATIONS = ['user', 'campaign', 'business', 'triggerSource'];
export function isValidRelation(value) {
    return VALID_RELATIONS.includes(value);
}
//# sourceMappingURL=includable-relation.type.js.map